/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface MerchantMerchantSubCategory { 
    archived?: boolean;
    createdAt?: string;
    id: string;
    importObjectKey?: string;
    importSessionKey?: string;
    locked?: boolean;
    path?: string;
    published?: boolean;
    readOnly?: boolean;
    title?: string;
    updatedAt?: string;
    version?: number;
}
